import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-99">
      {/* Background Image with Overlays */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/9CUPttAskT7kJR4HfeqMfs/Gemini_Generated_Image_4qlzcp4qlzcp4qlz.png")',
      backgroundPosition: 'center 20%' // Adjust to show more of the dome
    }} data-id="element-100" />

      {/* Cinematic Gradients */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-navy/40 via-transparent to-navy/90" data-id="element-101" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-navy via-navy/60 to-transparent h-3/4 mt-auto" data-id="element-102" />

      {/* Content */}
      <div className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 text-center mt-24" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-104">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-warmWhite mb-6 leading-tight text-balance" data-id="element-105">
            {t('hero.headline1')}
            <br data-id="element-106" />
            <span className="text-saffron italic" data-id="element-107">{t('hero.headline2')}</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-108">
          <p className="text-lg md:text-xl text-warmWhite/90 max-w-3xl mx-auto mb-12 font-light leading-relaxed text-balance" data-id="element-109">
            {t('hero.subheadline')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-110">
          <button onClick={() => scrollTo('support')} className="w-full sm:w-auto px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite transition-colors duration-300" data-id="element-111">
            {t('hero.cta1')}
          </button>
          <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-warmWhite/50 text-warmWhite rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite/10 hover:border-warmWhite transition-colors duration-300 text-center" data-id="element-112">
            {t('hero.cta2')}
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center" data-id="element-113">
        <span className="text-warmWhite/50 text-xs tracking-widest uppercase mb-2" data-id="element-114">
          {t('hero.scrollIndicator')}
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="w-[1px] h-12 bg-gradient-to-b from-saffron to-transparent" data-id="element-115" />
      </motion.div>
    </section>;
}